// extracted by mini-css-extract-plugin
export default {"spoiler_link":"style_spoiler_link__GrKOd"};